<template>
  <v-card tile flat class="d-flex">
    <v-sheet class="pa-4">
      <v-img
        v-bind:src="imagesrc"
      />
      <v-card-text>
        <p class="text-center">{{title}}</p>
      </v-card-text>
    </v-sheet>
  </v-card>  
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        required: false
      },
      bgColor: {
        type: String,
        required: false
      },
      imagesrc:{
        type: String,
        required: false
      },
      imageWidth:{
        type:String,
        required: false,
      }
    },
    data: () => ({
      //
    }),

    methods: {
      _getName(k){
        return "Khangal-" + k;  
      },
      _getBgColor(){
        if(this.bgColor!=undefined&&this.bgColor!=null) {
          return this.bgColor;
        }
        else 
          return "#bbb";
      }
    },
  }
</script>
<style scoped>



</style>